function generateWebHookUrl(userId, key) {
    return `${process.env.REACT_APP_API_URL}/wh/${userId}/${key}`;
}

module.exports = {
    generateWebHookUrl
}


